import React from 'react'
import ReactPlayer from "react-player"

import './About.css'

class About extends React.Component {
  render() {

    var imgRatio = this.props.isMobileSize ? { minHeight: 450, maxHeight: 800 } : { minHeight: 400, maxHeight: 500 };

    return (
      <div>
        <div id="navigation" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="overlay"></div>
              <img class="d-block w-100" style={imgRatio} src="/static/images/about/about-1.jpg" />
            </div>
            <div class="carousel-item">
              <div class="overlay"></div>
              <img class="d-block w-100" style={imgRatio} src="/static/images/about/about-2.jpg" />
            </div>
            <div class="carousel-item">
              <div class="overlay"></div>
              <img class="d-block w-100" style={imgRatio} src="/static/images/about/about-3.jpg" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#navigation" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          </a>
          <a class="carousel-control-next" href="#navigation" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
          </a>
        </div>
        <div class="container pt-5">
          <h1 className="text-center text-uppercase font-weight-light">Bik'Indoor révolutionne l’indoor cycling en proposant un entraînement complet.</h1>
          <p className="text-center lead">Entraînements, suivi personnalisé, résultats !</p>
        </div>
        <div className="container pt-5">
          <div className="row align-items-center">
            <div className="col-md-auto">
              <img className="round-image" src="/static/images/about/about-4.jpg" />
            </div>
            <div className="col">
              <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>A chaque objectif, son cours !</h1>
              <p className="lead">RPM, The Trip, Sprint, Cross Training, Yog’Indoor ou encore Box’Indoor : découvrez une large variété de séances pensées pour répondre à vos envies, vos besoins et vos objectifs. Grâce à des variantes proposées sur chaque activité, nos cours sont accessibles à tous, quels que soient votre niveau ou votre profil (débutants, confirmés, seniors, femmes enceintes…).</p>
              <p className="lead">Une fois membre du club, vous êtes libre de réserver les cours collectifs et les créneaux qui s’adaptent le mieux à votre emploi du temps. À vous de composer votre expérience, à votre rythme.</p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-auto">
              <img style={{ maxWidth: "250px" }} src="/static/images/about/about-5.png" />
            </div>
            <div className="col">
              <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Vous êtes au bon endroit !</h1>
              <p className="lead">Si vous recherchez des résultats durables, un accompagnement sur mesure et une réelle expertise, vous êtes exactement là où il faut. Nos coachs vous offrent une prise en charge complète, personnalisée et exigeante, de A à Z.</p>
              <p className="lead">Dès votre inscription, nous réalisons un bilan de forme approfondi grâce à notre impédancemètre. Cette analyse précise nous permet de comprendre votre corps, vos besoins et vos objectifs afin de concevoir un programme sportif parfaitement adapté;  qu’il s’agisse de perte de poids, de renforcement musculaire ou d’amélioration globale de votre condition physique.</p>
              <p className="lead">Dans cette même logique d’excellence, nous construisons également avec vous un plan nutritionnel personnalisé, pensé pour s’intégrer harmonieusement à votre mode de vie et optimiser vos résultats dans la durée.</p>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <h1 className="bk-blue" style={{ fontVariant: "small-caps" }}>Ils sont convaincus, pourquoi pas vous ?</h1>
          <div className='player-wrapper mt-2 mb-2'>
            <ReactPlayer
              className='react-player'
              volume="0.2"
              url="https://youtu.be/ORTmpH9sIZ8"
              width='100%'
              height='100%'
            />
          </div>
          <div className='player-wrapper mt-2 mb-2'>
            <ReactPlayer
              className='react-player'
              volume="0.2"
              url="https://youtu.be/efT6tkpLstA"
              width='100%'
              height='100%'
            />
          </div>
          <div className='player-wrapper mt-2 mb-2'>
            <ReactPlayer
              className='react-player'
              volume="0.2"
              url="https://www.youtube.com/watch?v=uiukOzQrp0Q"
              width='100%'
              height='100%'
            />
          </div>
        </div>
      </div>
    );
  }
}
export default About;